import { render, staticRenderFns } from "./SVG-WhosTraveling.vue?vue&type=template&id=548500d9&scoped=true&"
import script from "./SVG-WhosTraveling.vue?vue&type=script&lang=js&"
export * from "./SVG-WhosTraveling.vue?vue&type=script&lang=js&"
import style0 from "./SVG-WhosTraveling.vue?vue&type=style&index=0&id=548500d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548500d9",
  null
  
)

export default component.exports